// removed by extract-text-webpack-plugin
module.exports = {"controlLabel":"_1Nz-B7tHgvlb8pu7zlNmpK"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UpdateAmountForm/styles.css
// module id = 3200
// module chunks = 0